import { BACKEND_URL } from "API_ENDPOINT";
// takes an array of domain strings and returns an array of domain metadata objects.
export const GET_DNS_METADATA = async (domain) => {
  const response = await fetch(`${BACKEND_URL}/dnslookup?domain=${domain}`);
  const json = await response.json();

  return json.metadata;
};
